// removed by extract-text-webpack-plugin
module.exports = {"renew-subscription-notification":"renew-subscription-notification","subscription-description":"subscription-description","button-subscription":"button-subscription"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/notifications/component/renew-subscription-notification/renew-subscription-notification.style.sass
// module id = hqfj
// module chunks = 0